import date from './date'
import numberic from './numberic'
import required from './required'
import min from './min.js'
import max from './max.js'
import len from './len.js'
import email from './email.js'
import identity from './identity.js'

export default {
  date,
  min,
  max,
  len,
  email,
  numberic,
  required,
  identity
}



// WEBPACK FOOTER //
// ./src/validator/index.js